import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import UserSidebar from "../../Component/UserSidebar";
import Details from "./details";
import config from "../../config";
import queryString from "query-string";
import { useSelector, useDispatch } from "react-redux";
import { loadMentors, saveSelectMentor, getFilterData } from "./Slice/menteeListingSlice";
import { updateUserData } from "../DashboardMentor/Slice/dashboardMentorSlice";
import PropTypes from "prop-types";

function SidebarAddClass() {
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("show_sidebar");
}

const Index = (props) => {

  const dispatch = useDispatch();
  const { mentorsData } = useSelector((state) => state?.menteeListing);
  const { isAuth, userInfo } = useSelector((state) => state?.user);

  const { title } = props;
  const [modalShow, setModalShow] = useState(false);
  const [userData, setUserData] = useState({});
  const location = useLocation();

  const getMentor = (e, mentorId) => {
    e.preventDefault();
    if (isAuth === false) {
      history(`/login`);
    }
    const userId = userInfo.id;
    const request = {};
    request.userId = userId;
    request.mentorId = mentorId;
    dispatch(saveSelectMentor(request));
    dispatch(updateUserData(request));
  };

  const getUserDetails = (
    first_name,
    image,
    organization,
    position,
    about,
    linkedin
  ) => {
    setModalShow(true);
    setUserData({
      first_name: first_name,
      image: image,
      organization: organization,
      position: position,
      about: about,
      linkedin: linkedin,
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    const request = {};
    if (params.get("sort")) {
      const sort = queryStringParsed["sort"];
      const direction = queryStringParsed["direction"];
      request.sort = sort;
      request.direction = direction;
    }
    if (params.get("page")) {
      const page = queryStringParsed["page"];
      request.page = page;
    }
    if (params.get("keyword")) {
      const keyword = queryStringParsed["keyword"];
      request.keyword = keyword;
    }
    if (params.get("domains")) {
      const domains = queryStringParsed["domains"];
      request.domains = domains;
    }
    dispatch(getFilterData());

    dispatch(
      loadMentors({
        request,
        domain: isAuth ? userInfo.domains : "",
      })
    );
    window.scrollTo(0, 0);
    document.title = title;
  }, [title, location, userInfo, isAuth]);

  const history = useNavigate();

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />

        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to="#"
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h2 className="dash_heading">Dashboard</h2>

          <div className="box_wrap shadow-sm bg-white mentor_box">
            <h3 className="text-center mw-950">
              Based on your preferred domain and objectives these are mentors
              available. Please check mentor details and select your mentor.
            </h3>
            <div className="mentor_list dash_MentorList">
              {/* {mentorsData && */}
              {mentorsData.map((item, key) => (
                <Col xs={12} xl={3} lg={4} md={6} sm={6} key={item.id}>
                  <div className="outer position-relative">
                    <div className="mentor_img">
                      {item.image && (
                        <img
                          src={config.IMAGEROOTPATHLOCAL + item.image}
                          alt="mentor"
                        />
                      )}
                      {!item.image && (
                        <img
                          src="assets/images/mentor_women_two.jpg"
                          alt="business career mentor program"
                        />
                      )}
                    </div>
                    <div className="mentor_info">
                      <h3>{item.first_name}</h3>
                      <h6>{item.position}</h6>
                      <p>
                        {item.organization !== "undefined" ||
                          item.organization === ""
                          ? item.organization
                          : "N/A"}
                      </p>
                    </div>
                    <div className="mentor_btn">
                      <div>
                        <Link
                          to=""
                          onClick={(e) => {
                            getMentor(e, item.id);
                          }}
                        >
                          Select as Mentor
                        </Link>

                        <Link
                          id={key}
                          onClick={(e) => {
                            getUserDetails(
                              item.first_name,
                              item.image,
                              item.organization,
                              item.position,
                              item.about,
                              item.linkedin
                            );
                          }}
                        >
                          {" "}
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </div>
          </div>
        </div>
      </div>
      <button type="button" className="sidebar_overlay" onClick={SidebarRemoveClass}></button>
      {modalShow && (
        <Details
          show={modalShow}
          userdata={userData}
          onHide={() => setModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
    </div>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Index;
